import { WithdrawState } from "@/domains/lock-page/withdraw-store"

type customIcon = "spinner" | "completed" | "failed" | "onchain-action"

type WithdrawStep = {
  number: number
  title: string
  key: string
  className: string
  dataContent?: string
  customIcon?: customIcon
}

export const withdrawStepMap: Record<WithdrawState, Array<WithdrawStep>> = {
  idle: [
    {
      number: 1,
      title: "Waiting",
      key: "expired",
      className: "step step-neutral",
    },
    { number: 2, title: "Reset", key: "reset", className: "step step-neutral" },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral" },
  ],
  "checking-expired": [
    {
      number: 1,
      title: "Checking",
      key: "expired",
      className: "step step-neutral step-primary",
      customIcon: "spinner",
    },
    { number: 2, title: "Reset", key: "reset", className: "step step-neutral" },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral" },
  ],
  "not-expired": [
    {
      number: 1,
      title: "Not Expired",
      key: "expired",
      className: "step step-neutral step-error",
      customIcon: "failed",
    },
    { number: 2, title: "Reset", key: "reset", className: "step step-neutral" },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral" },
  ],
  expired: [
    {
      number: 1,
      title: "Expired",
      key: "expired",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    { number: 2, title: "Reset", key: "reset", className: "step step-neutral step-primary" },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral" },
  ],
  "checking-reset-required": [
    {
      number: 1,
      title: "Expired",
      key: "expired",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Checking",
      key: "reset",
      className: "step step-neutral step-primary",
      customIcon: "spinner",
    },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral" },
  ],
  "reset-required": [
    {
      number: 1,
      title: "Expired",
      key: "expired",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Reset",
      key: "reset",
      className: "step step-neutral step-primary",
      // customIcon: "onchain-action",
    },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral" },
  ],
  resetting: [
    {
      number: 1,
      title: "Expired",
      key: "expired",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Resetting",
      key: "reset",
      className: "step step-neutral step-primary",
      customIcon: "onchain-action",
    },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral" },
  ],
  "reset-failed": [
    {
      number: 1,
      title: "Expired",
      key: "expired",
      className: "step step-neutral step-primary step-success",
      customIcon: "completed",
    },
    { number: 2, title: "Reset", key: "reset", className: "step step-neutral step-error", customIcon: "failed" },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral" },
  ],
  "withdraw-allowed": [
    {
      number: 1,
      title: "Expired",
      key: "expired",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Reset",
      key: "reset",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral step-primary" },
  ],
  withdrawing: [
    {
      number: 1,
      title: "Expired",
      key: "expired",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Reset",
      key: "reset",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 3,
      title: "Withdrawing",
      key: "withdraw",
      className: "step step-primary",
      customIcon: "onchain-action",
    },
  ],
  "withdraw-failed": [
    {
      number: 1,
      title: "Expired",
      key: "expired",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Reset",
      key: "reset",
      className: "step step-neutral step-primary step-success",
      customIcon: "completed",
    },
    { number: 3, title: "Withdraw", key: "withdraw", className: "step step-neutral step-error", customIcon: "failed" },
  ],
  withdrawn: [
    {
      number: 1,
      title: "Expired",
      key: "expired",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Reset",
      key: "reset",
      className: "step step-success",
      customIcon: "completed",
    },
    { number: 3, title: "Withdrawn", key: "withdraw", className: "step step-success", customIcon: "completed" },
  ],
}
